import React, { useCallback, useEffect, useState, useRef } from 'react';
import './stocksummary.css';
import { useLocation, useNavigate, useNavigation, useNavigationType } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Stock_Summary_Help from '../../../components/help/stock_summary/Stock_Summary_Help';
import Period from '../../../components/help/stock_summary/stock_summary_component/Period';
import Configure from '../../../components/help/stock_summary/stock_summary_component/Configure';
import Company from '../../../components/help/stock_summary/stock_summary_component/Company';
import Stock_Group from '../../../components/help/stock_summary/stock_summary_component/Stock_Group';
import BasicValue from '../../../components/help/stock_summary/stock_summary_component/BasicValue';
import ChangeView from '../../../components/help/stock_summary/stock_summary_component/ChangeView';
import ExceptionReports from '../../../components/help/stock_summary/stock_summary_component/ExceptionReports';
import SaveView from '../../../components/help/stock_summary/stock_summary_component/SaveView';
import Valuation from '../../../components/help/stock_summary/stock_summary_component/Valuation';
import SummaryType from '../../../components/help/stock_summary/stock_summary_component/SummaryType';
import { closeModal, openModal, stockSummaryList, saveStockSummaryState } from '../../../redux/actions/action-creator';
import { dateFormateSend, dateFormateShow, currencyFormate } from '../../../components/Date_Formate_Utilitiy/Index';
import GodownFilter from '../../../components/help/stock_summary/stock_summary_component/GodownFilter';
import Stock_Category from '../../../components/help/stock_summary/stock_summary_component/Stock_Category';
import StockItemSummaryFooter from '../../../components/Footer/StockItemSummaryFooter';
import { useDropdownScroll } from '../../../components/Custom_Hooks/useDropdownScroll';
import { stockData } from './stockData';
import { useDropdownKeyboardNavigation } from '../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import Indicator from '../../../components/Indicator/Indicator';

const parseVal = (val) => {
  if (val === null || val === undefined) return 0;
  if (typeof val === 'number') return val;
  const clean = String(val).replace(/,/g, '');
  const parsed = parseFloat(clean);
  return isNaN(parsed) ? 0 : parsed;
};

const formatValue = (val, formatter = null) => {
  if (val === null || val === undefined) return null;
  const clean = String(val).replace(/,/g, '');
  const parsed = parseFloat(clean);
  if (isNaN(parsed) || parsed === 0) return null;
  return formatter ? formatter(val) : val;
};

const StockSummary = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData = null } = useSelector(state => state.auth);
  const { company_session } = useSelector(state => state.common);
  const modal_state = useSelector(state => state.common.modal_state);
  const persistedState = useSelector(state => state.common.stock_summary_persisted_state);
  const navType = useNavigationType();
  const isBackOrReload = navType === 'POP';


  const defaultDate = {
    show_from_date: dateFormateShow(company_session?.start_financial_year),
    show_to_date: dateFormateShow(company_session?.current_date),
    send_from_date: company_session?.start_financial_year,
    send_to_date: company_session?.current_date,
    location_id: '',
    location_name: 'Primary',
    stock_category_id: '',
    stock_group_id: '',
    stock_company_id: '',
    filter_name: 'Group-Wise',
    name_nav: `Primary`,
  };
  const [date, setDate] = useState(
    (isBackOrReload && persistedState?.date) ? persistedState.date : defaultDate
  );

  const [state_configure, setState_configure] = useState({
    show_quantity: 'No',
    show_alternate_unit: 'No',
    show_tail_unit_of_compound_unit: 'No',
    show_rate: 'No',
    show_value: 'No',
    show_opening_balance: 'No',
    show_goods_inwards: 'No',
    show_goods_outwards: 'No',
    show_gross_value_of_outwards: 'No',
    show_comsumption_and_gross_profit: 'No',
    show_gross_profits_on_gross_value: 'No',
    show_closing_balance: 'No',
    show_stock_item_with_zero_qty_or_blc: 'No',
    exclude_detail_with_no_transaction: 'No',
    type_of_grouping: '',
    items_formate_of_report: 'Condensed',
    godowns_formate_of_report: 'Hide',
    expand_all_level_in_details_formate: 'No',
    display_name: 'Name Only',
    sorting_method: 'Default',
  })

  const [removedItems, setRemovedItems] = useState([])
  const [data, setData] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedItem, setSelectedItem] = useState(0)
  const [selectedItems, setSelectedItems] = useState([]);
  const [f4Enable, setF4Enable] = useState(false);
  const boxRef = useRef(null)

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);
  //       setRawData(stockData);
  //     } catch (error) {
  //       setRawData([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, [date])

  // Syncing is handled by a unified useEffect below

  useEffect(() => {
    const fetchData = async () => {
      //console.log('fetchData', date);
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append('fromDate', dateFormateSend(date.send_from_date));
        formData.append('toDate', dateFormateSend(date.send_to_date));
        formData.append('company_id', userData.id);
        formData.append('location_id', date.location_id);
        formData.append('stock_cat_id', date.stock_category_id);
        formData.append('stock_gp_id', date.stock_group_id);
        formData.append('stock_company_id', date.stock_company_id);
        formData.append('filter_name', date.filter_name);
        const response = await dispatch(stockSummaryList(formData));
        //console.log('fetchData', response.data);
        if (response && response.status) {
          setRawData(response.data);
          // setRawData(stockData);
        } else {
          // setRawData(response.data);
          setRawData(stockData);
        }
      } catch (error) {
        setRawData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [date])

  const filterDataCoonfigure = useCallback(() => {
    // Determine the report format key from the state (handle both naming conventions)
    const reportFormat = state_configure?.items_formate_of_report || state_configure?.formate_of_report || 'Condensed';

    let processedRawData = rawData || [];

    if (date?.filter_name === 'Group-Wise' && processedRawData.length > 0) {
      const buildTreeAndFlatten = (dataList) => {
        const idMapping = dataList.reduce((acc, el, i) => {
          const id = el.stock_group_id || el.group_id || el.stock_gp_id || el.id || String(i);
          acc[id] = { ...el, depth: 0, children: [] };
          return acc;
        }, {});

        const filteredGroupIds = date.stock_group_id
          ? date.stock_group_id.split(',').map(s => String(s.trim()))
          : [];
        const hasFilter = filteredGroupIds.length > 0;

        const mainParentNodeEl = dataList.find(el => {
          if (hasFilter) {
            const id = el.stock_group_id || el.group_id || el.stock_gp_id || el.id;
            return filteredGroupIds.includes(String(id));
          } else {
            return el.group_name === 'Primary';
          }
        });

        const mainParentId = mainParentNodeEl ? (mainParentNodeEl.stock_group_id || mainParentNodeEl.group_id || mainParentNodeEl.stock_gp_id || mainParentNodeEl.id) : null;

        let rootNodes = [];
        dataList.forEach((el, i) => {
          const id = el.stock_group_id || el.group_id || el.stock_gp_id || el.id || String(i);

          if (!hasFilter && el.group_name === 'Primary') {
            return;
          }

          const parentId = el.parent_group_id || el.under || null;

          // If no filter, we promote children of Primary to root.
          // If filter is active, we keep hierarchy normal (no promotion of children of mainParentGroupId).
          const parentIsPrimary = !hasFilter && (!parentId || parentId === 'Primary' || parentId === mainParentId || !idMapping[parentId]);

          if (!parentIsPrimary && idMapping[parentId] && parentId !== id) {
            idMapping[parentId].children.push(idMapping[id]);
          } else {
            rootNodes.push(idMapping[id]);
          }
        });

        const calculateTotals = (node) => {
          let directOpening = 0;
          let directInward = 0;
          let directOutward = 0;
          let directClosing = 0;

          if (node.items) {
            node.items.forEach(item => {
              directOpening += parseVal(item.grandOpeningData?.value || item.openingData?.value || 0);
              directInward += parseVal(item.grandInwardData?.value || item.inwardData?.value || 0);
              directOutward += parseVal(item.grandOutwardData?.value || item.outwardData?.value || 0);
              directClosing += parseVal(item.grandClosingData?.value || item.closingData?.value || 0);
            });
          }

          let childrenOpening = 0;
          let childrenInward = 0;
          let childrenOutward = 0;
          let childrenClosing = 0;

          if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
              calculateTotals(child);
              childrenOpening += parseVal(child.openingTotal || 0);
              childrenInward += parseVal(child.inwardTotal || 0);
              childrenOutward += parseVal(child.outwardTotal || 0);
              childrenClosing += parseVal(child.closingTotal || 0);
            });
          }

          node.openingTotal = directOpening + childrenOpening;
          node.inwardTotal = directInward + childrenInward;
          node.outwardTotal = directOutward + childrenOutward;
          node.closingTotal = directClosing + childrenClosing;
        };

        // Always calculate totals for all root nodes to cover the entire hierarchy
        rootNodes.forEach(node => {
          calculateTotals(node);
        });
        if (!hasFilter && mainParentNodeEl) {
          const mainId = mainParentNodeEl.stock_group_id || mainParentNodeEl.group_id || mainParentNodeEl.stock_gp_id || mainParentNodeEl.id;
          calculateTotals(idMapping[mainId]);
        }

        const flattened = [];
        const dfs = (nodes, depth) => {
          // Sort nodes alphabetically by group_name before traversing
          const sortedNodes = [...nodes].sort((a, b) => {
            const nameA = (a.group_name || '').toLowerCase();
            const nameB = (b.group_name || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });

          sortedNodes.forEach(node => {
            const { children, ...rest } = node;
            const nodeId = String(rest.stock_group_id || rest.group_id || rest.stock_gp_id || rest.id);
            const isFilteredParent = hasFilter && filteredGroupIds.includes(nodeId);

            // If it is the main parent group and filter is active, we hide its items for the first entry
            if (isFilteredParent) {
              flattened.push({ ...rest, depth, hideItems: true });
            } else {
              flattened.push({ ...rest, depth });
            }

            let shouldTraverseChildren = true;
            if (reportFormat === 'Condensed') {
              if (hasFilter) {
                // with filter top group and their subgroup will show
                shouldTraverseChildren = true;
              } else {
                // without filter only top group will show
                shouldTraverseChildren = false;
              }
            }

            if (shouldTraverseChildren && children.length > 0) {
              dfs(children, depth + 1);
            }

            if (isFilteredParent) {
              flattened.push({ ...rest, depth, hideRow: true });
            }
          });
        };

        dfs(rootNodes, 0);

        // Append the main parent group's items at the very end
        if (!hasFilter && mainParentNodeEl) {
          const mainId = mainParentNodeEl.stock_group_id || mainParentNodeEl.group_id || mainParentNodeEl.stock_gp_id || mainParentNodeEl.id;
          const { children, ...rest } = idMapping[mainId];
          flattened.push({ ...rest, depth: 0, hideRow: true });
        }

        return flattened;
      };

      processedRawData = buildTreeAndFlatten(processedRawData);
    }

    const newData = processedRawData?.map(outerItem => {
      const items = outerItem?.items || [];
      const sortedItems = [...items].sort((a, b) => {
        const nameA = (a?.stock_item?.item_name || '').toLowerCase();
        const nameB = (b?.stock_item?.item_name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
      const expandedItems = sortedItems.map(item => {
        const godownData = item?.godown_data?.map(g => ({
          ...g,
          grandOpeningData: g.openingData || g.grandOpeningData,
          grandInwardData: g.inwardData || g.grandInwardData,
          grandOutwardData: g.outwardData || g.grandOutwardData,
          grandClosingData: g.closingData || g.grandClosingData,
          stock_item: null
        })) || [];

        // Apply filters to godownData to align with active location selection and zero balance configurations
        const filteredGodownData = godownData.filter(g => {
          // 0. Filter out godowns with empty names
          const name = g.location_name || g.godown_name || g.name || '';
          if (name.trim() === '') {
            return false;
          }

          // 1. Filter by location_id if selected
          if (date?.location_id && date?.location_id !== '') {
            const selectedLocationIds = date.location_id.split(',').map(id => id.trim());
            const currentLocId = String(g.location_id || g.id || '');
            if (!selectedLocationIds.includes(currentLocId)) {
              return false;
            }
          }

          // Helper to check if a godown has any transaction/balance
          const opQty = parseVal(g.grandOpeningData?.quantity);
          const opVal = parseVal(g.grandOpeningData?.value);
          const inQty = parseVal(g.grandInwardData?.quantity);
          const inVal = parseVal(g.grandInwardData?.value);
          const outQty = parseVal(g.grandOutwardData?.quantity);
          const outVal = parseVal(g.grandOutwardData?.value);
          const clQty = parseVal(g.grandClosingData?.quantity);
          const clVal = parseVal(g.grandClosingData?.value);

          const hasTxn = opQty !== 0 || opVal !== 0 || inQty !== 0 || inVal !== 0 || outQty !== 0 || outVal !== 0 || clQty !== 0 || clVal !== 0;

          // 2. Exclude details with no transaction
          if (state_configure?.exclude_detail_with_no_transaction === 'Yes' && !hasTxn) {
            return false;
          }

          // 3. Show stock items/details with zero qty or blc check
          if (state_configure?.show_stock_item_with_zero_qty_or_blc === 'No') {
            const hasQtyOrBlc = clQty !== 0 || clVal !== 0 || hasTxn;
            if (!hasQtyOrBlc) {
              return false;
            }
          }

          return true;
        });

        return state_configure?.godowns_formate_of_report === 'Hide' ? [item] : [item, ...filteredGodownData]
      }).flat();

      const isPrimary = outerItem?.group_name === 'Primary' ||
        outerItem?.category_name === 'Not Applicable' ||
        outerItem?.company_name === 'Not Applicable' ||
        outerItem?.category_name === 'Primary' ||
        outerItem?.company_name === 'Primary';

      const isFilteredMainParent = date?.filter_name === 'Group-Wise' &&
        date.stock_group_id !== '' &&
        (date.stock_group_id.split(',').map(s => String(s.trim())).includes(String(outerItem?.stock_group_id || outerItem?.group_id || outerItem?.stock_gp_id || outerItem?.id)));

      const isMainParent = isPrimary || isFilteredMainParent;

      const finalItems = outerItem.hideItems ? [] : expandedItems;

      return {
        ...outerItem,
        // In Item-Wise mode, we always want to show the items, regardless of Condensed/Detailed setting.
        // In other modes, we only show items if the format is Detailed, or if it is a main parent group.
        items: (date?.filter_name === 'Item-Wise' || reportFormat === 'Detailed' || isMainParent) ? finalItems : [],
      };
    });
    setData(newData)
  }, [state_configure, rawData, date])

  useEffect(() => {
    filterDataCoonfigure();
  }, [filterDataCoonfigure]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'F1' && !e.altKey) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (e.key === 'Escape') {
        // If any modal is open, let the global modal handler or local modal handler take care of it
        if (Object.values(modal_state || {}).some(val => val)) {
          return;
        }

        const hasFilter = date.location_id !== '' ||
          date.stock_category_id !== '' ||
          date.stock_group_id !== '' ||
          date.stock_company_id !== '' ||
          date.filter_name !== 'Group-Wise' ||
          date.name_nav !== 'Primary';

        if (hasFilter) {
          e.preventDefault();
          e.stopPropagation();

          const defaultState = {
            ...date,
            location_id: '',
            stock_category_id: '',
            stock_group_id: '',
            stock_company_id: '',
            filter_name: 'Group-Wise',
            name_nav: 'Primary',
          };

          setDate(defaultState);

          dispatch(saveStockSummaryState({
            date: defaultState,
            state_configure,
            selectedItemIndex: 0
          }));
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown, true);
    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [date, modal_state, state_configure, dispatch]);



  const focusableItems = React.useMemo(() => {
    const list = [];
    data?.forEach((outerItem, outerIndex) => {
      const isHiddenPrimaryRow = date?.filter_name === 'Group-Wise' && outerItem?.group_name === 'Primary';
      const isHiddenRow = isHiddenPrimaryRow || outerItem?.hideRow === true;
      if (date?.filter_name !== 'Item-Wise' && !isHiddenRow) {
        list.push({ isParent: true, outerItem, _outerIndex: outerIndex });
      }
      outerItem?.items?.forEach((item, innerIndex) => {
        list.push({ ...item, isParent: false, _outerIndex: outerIndex, _innerIndex: innerIndex });
      });
    });
    return list;
  }, [data, date?.filter_name]);

  const onNavigateAway = (index) => {
    dispatch(saveStockSummaryState({
      date,
      state_configure,
      selectedItemIndex: index
    }));
  };

  const hasRestoredIndex = useRef(false);

  const { selectedItemIndex, setSelectedItemIndex } =
    useDropdownKeyboardNavigation({
      enableAlphaJump: true,
      items: focusableItems,
      initialIndex: (isBackOrReload && persistedState?.selectedItemIndex) ? persistedState.selectedItemIndex : 0,
      state:
        Object.keys(modal_state || {}).some(key => modal_state[key])
          ? false
          : true,
      onItemSelect: (item) => {
        if (item.isParent) {
          if (date.filter_name !== 'Item-Wise') {
            const isFilteredMainParent = date?.filter_name === 'Group-Wise' &&
              date.stock_group_id !== '' &&
              (date.stock_group_id.split(',').map(s => String(s.trim())).includes(String(item.outerItem?.stock_group_id || item.outerItem?.group_id || item.outerItem?.stock_gp_id || item.outerItem?.id)));

            if (isFilteredMainParent) {
              return; // Do nothing for filtered main parent group row
            }
            //console.log(item, 'selected item');
            const newDate = { ...date };
            let newNameNav = date.name_nav;

            if (date.filter_name === 'Group-Wise') {
              newDate.stock_group_id = item.outerItem?.stock_group_id || item.outerItem?.group_id || item.outerItem?.stock_gp_id || item.outerItem?.under || item.outerItem?.stock_item?.under || item.outerItem?.id || '';
              newNameNav = item.outerItem?.group_name || newNameNav;
              newDate.filter_name = 'Group-Wise';
            } else if (date.filter_name === 'Category-Wise') {
              newDate.stock_category_id = item.outerItem?.stock_category_id || item.outerItem?.category_id || item.outerItem?.stock_cat_id || item.outerItem?.under || item.outerItem?.stock_item?.under || item.outerItem?.id || '';
              newNameNav = item.outerItem?.category_name || newNameNav;
              newDate.filter_name = 'Category-Wise';
            } else if (date.filter_name === 'Company-Wise') {
              newDate.stock_company_id = item.outerItem?.stock_company_id || item.outerItem?.company_id || item.outerItem?.under || item.outerItem?.stock_item?.under || item.outerItem?.id || '';
              newNameNav = item.outerItem?.company_name || newNameNav;
              newDate.filter_name = 'Company-Wise';
            }

            newDate.name_nav = newNameNav !== 'Primary' ? newNameNav : '';

            setDate(newDate);
            setSelectedItemIndex(0);
          } else {
            // When already Item-Wise but row is somehow parent (e.g. single item mode)
            let idToPass = item.outerItem?.stock_item?.stock_item_id || '0';
            let stateToPass = {
              location_id: date.location_id,
              location_name: date.location_name || 'Primary',
              filter_name: date.filter_name,
              filter_value_names: date.name_nav !== 'Primary' ? date.name_nav : '',
              stock_group_id: date.stock_group_id || '',
              stock_category_id: date.stock_category_id || '',
              stock_company_id: date.stock_company_id || '',
              send_from_date: date.send_from_date,
              send_to_date: date.send_to_date
            };
            onNavigateAway(selectedItemIndex);
            navigate(`../stock_item_voucher/${idToPass}`, {
              state: stateToPass
            });
          }
          return;
        }
        if (item?.grandOpeningData?.stock_item_id) {
          onNavigateAway(selectedItemIndex);
          navigate(`../stock_item_voucher/${item.grandOpeningData.stock_item_id}`, {
            state: {
              location_id: item.location_id || date.location_id,
              location_name: item.location_name || date.location_name || 'Primary',
              filter_name: date.filter_name,
              filter_value_names: date.name_nav !== 'Primary' ? date.name_nav : '',
              stock_group_id: date.stock_group_id || '',
              stock_category_id: date.stock_category_id || '',
              stock_company_id: date.stock_company_id || '',
              send_from_date: date.send_from_date,
              send_to_date: date.send_to_date
            }
          });
        }
      },
      onItemSpaceSelect: (item) => {
        toggleSelection(selectedItemIndex);
      },
      onItemAltRSelect: (item) => {
        removeSelectedItems();
      },
      onItemAltUSelect: (item) => {
        restoreSelectedItems();
      },
      onItemF1Select: (item) => {
        // Restricted F1 standalone press
      },
      onItemAltF1Select: (item) => {
        if (date.filter_name !== 'Item-Wise') {
          setState_configure(prevState => ({
            ...prevState,
            items_formate_of_report: prevState.items_formate_of_report === 'Condensed' ? 'Detailed' : 'Condensed'
          }));
        }
      },
      onItemF2Select: (item) => {
        //setLoading(true);
        dispatch(openModal("period"));
      },
      onItemF3Select: (item) => {
        // setLoading(true);
        // dispatch(openModal("stockGroup"));
      },
      onItemF4Select: (item) => {
        setLoading(true);
        const filter = date.filter_name;
        if (filter === 'Group-Wise') {
          dispatch(openModal("stockGroup"));
        } else if (filter === 'Category-Wise') {
          dispatch(openModal("stockCate"));
        } else if (filter === 'Company-Wise') {
          dispatch(openModal("stockCompany"));
        } else {
          setF4Enable(false);
          setLoading(false);
        }
      },
      onItemF5Select: (item) => {
        //setLoading(true);
        dispatch(openModal("summaryType"));
      },
      onItemF6Select: (item) => {
        //setLoading(true);
        dispatch(openModal("periodType"));
      },
      onItemF7Select: (item) => {
        //setLoading(true);
        dispatch(openModal("godownWise"));
      },
      onItemAltF7Select: (item) => {
        if (date.filter_name == 'Item-Wise' || state_configure.items_formate_of_report === 'Detailed') {
          setState_configure(prevState => ({
            ...prevState,
            godowns_formate_of_report: prevState.godowns_formate_of_report === 'Hide' ? 'Show' : 'Hide'
          }));
        }
      },
      onItemAltFSelect: (item) => {
        //setLoading(true);
        dispatch(openModal("applyFilter"));
      },
      onItemSSelect: (item) => {
        //setLoading(true);
        dispatch(openModal("share"));
      },
      onItemPSelect: (item) => {
        //setLoading(true);
        dispatch(openModal("print"));
      },
      onItemF12Select: (item) => {
        //setLoading(true);
        dispatch(openModal("configure"));
      },
      getLabel: (item) => {
        if (item.isParent) {
          return (item.outerItem?.group_name || item.outerItem?.category_name || item.outerItem?.company_name || '').trim();
        }
        const itemName = item.stock_item?.item_name || '';
        const locationName = item.location_name || item.godown_name || item.name || '';
        return (itemName + ' ' + locationName).trim();
      }
    });

  useEffect(() => {
    if (isBackOrReload && persistedState?.selectedItemIndex !== undefined && focusableItems.length > 0 && !hasRestoredIndex.current) {
      setSelectedItemIndex(persistedState.selectedItemIndex);
      hasRestoredIndex.current = true;
    }
  }, [focusableItems.length, isBackOrReload, persistedState, setSelectedItemIndex]);

  // Sync persistedState when date or state_configure or selectedItemIndex changes so that reload/back navigation preserves them
  useEffect(() => {
    dispatch(saveStockSummaryState({
      date,
      state_configure,
      selectedItemIndex: selectedItemIndex
    }));
  }, [date, state_configure, selectedItemIndex, dispatch]);

  // Handle detailedCondensed modal toggle action
  useEffect(() => {
    if (modal_state?.detailedCondensed) {
      if (date.filter_name !== 'Item-Wise') {
        setState_configure(prevState => ({
          ...prevState,
          items_formate_of_report: prevState.items_formate_of_report === 'Condensed' ? 'Detailed' : 'Condensed'
        }));
      }
      dispatch(closeModal("detailedCondensed"));
    }
  }, [modal_state?.detailedCondensed, date.filter_name, dispatch]);
  useEffect(() => {
    const filter = date.filter_name;
    if (filter === 'Group-Wise' || filter === 'Category-Wise' || filter === 'Company-Wise') {
      setF4Enable(true);
    } else {
      setF4Enable(false);
    }
  }, [f4Enable, date.filter_name]);

  useDropdownScroll({ dropdownRef: boxRef, selectedItemIndex });
  // Function to toggle selection of an item
  const toggleSelection = (index) => {
    const selectedIndex = selectedItems.indexOf(index);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add the item to the selection if not already selected
      newSelected = newSelected.concat(selectedItems, index);
    } else if (selectedIndex === 0) {
      // Remove the item from the selection if already selected
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }
    setSelectedItems(newSelected);
  };

  // Function to remove selected items
  const removeSelectedItems = () => {
    if (selectedItems.length > 0) {
      const selectedIndices = [...selectedItems].sort((a, b) => a - b);
      const removedItemsList = [];

      selectedIndices.forEach(index => {
        removedItemsList.push({
          index: index,
          item: focusableItems[index]
        });
      });

      const updatedItemsToRemove = selectedIndices.map(idx => focusableItems[idx]);
      let updatedData = data?.filter((outerItem, oIdx) => {
        return !updatedItemsToRemove.some(rem => rem.isParent && rem._outerIndex === oIdx);
      });
      updatedData = updatedData?.map(outerItem => {
        if (!outerItem?.items) return outerItem;
        return {
          ...outerItem,
          items: outerItem.items.filter(it => !updatedItemsToRemove.some(rem => !rem.isParent && rem.grandOpeningData?.stock_item_id === it.grandOpeningData?.stock_item_id && rem.location_id === it.location_id))
        };
      });

      setData(updatedData);
      setRemovedItems([...removedItems, ...removedItemsList]);
      setSelectedItems([]);
      setSelectedItemIndex(0);
    } else {
      const removedObj = focusableItems[selectedItemIndex];
      if (!removedObj) return;

      let updatedData = data;
      if (removedObj.isParent) {
        updatedData = data?.filter((_, oIdx) => oIdx !== removedObj._outerIndex);
      } else {
        updatedData = data?.map(outerItem => {
          if (!outerItem?.items) return outerItem;
          return {
            ...outerItem,
            items: outerItem.items.filter(it => !(removedObj.grandOpeningData?.stock_item_id === it.grandOpeningData?.stock_item_id && removedObj.location_id === it.location_id))
          };
        });
      }

      setData(updatedData);
      setRemovedItems([
        ...removedItems,
        { index: selectedItemIndex, item: removedObj },
      ]);
    }
  };

  // Function to restore selected items
  const restoreSelectedItems = () => {
    if (removedItems.length === 0) {
      return;
    }

    const lastRemovedItem = removedItems[removedItems.length - 1];
    const { index: originalIndex, item: restoredObj } = lastRemovedItem;

    let updatedData = data;
    if (restoredObj.isParent) {
      updatedData = [...(data || [])];
      updatedData.splice(restoredObj._outerIndex, 0, restoredObj.outerItem);
    } else {
      updatedData = data?.map((outerItem, oIdx) => {
        if (oIdx === restoredObj._outerIndex) {
          const newItems = [...(outerItem.items || [])];
          const plainItem = { ...restoredObj };
          delete plainItem._outerIndex;
          delete plainItem._innerIndex;
          delete plainItem.isParent;
          newItems.splice(restoredObj._innerIndex, 0, plainItem);
          return {
            ...outerItem,
            items: newItems
          };
        }
        return outerItem;
      });
    }

    setData(updatedData);

    let insertIndex = originalIndex;
    const itemsRemovedBefore = removedItems.filter(removedItem =>
      removedItem.index < originalIndex
    ).length;
    insertIndex = originalIndex - itemsRemovedBefore;

    setSelectedItemIndex(insertIndex);
    setRemovedItems(removedItems.slice(0, -1));
  };

  let total_opnening_quantity = 0;
  let total_inwards_quantity = 0;
  let total_outwards_quantity = 0;
  let total_closing_quantity = 0;
  let total_opening_value = 0;
  let total_inwards_value = 0;
  let total_outwards_value = 0;
  let total_closing_value = 0;
  let unit_name = '';
  let currentGlobalIndex = 0;
  return (
    <div className='section'>
      <div className='detail'>
        {
          modal_state.period ?
            <Period
              setDate={setDate}
              date={date}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.stockGroup ?
            <Stock_Group
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.godownWise ?
            <GodownFilter
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.stockCate ?
            <Stock_Category
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.stockCompany ?
            <Company
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.configure ?
            <Configure
              state_configure={state_configure}
              setState_configure={setState_configure}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.basic ? <BasicValue setLoading={setLoading} /> : null
        }
        {
          modal_state.changeView ? <ChangeView setLoading={setLoading} /> : null
        }
        {
          modal_state.exceptionReports ? <ExceptionReports setLoading={setLoading} /> : null
        }
        {
          modal_state.saveView ? <SaveView setLoading={setLoading} /> : null
        }
        {
          modal_state.valuation ? <Valuation setLoading={setLoading} /> : null
        }
        {
          modal_state.summaryType ?
            <SummaryType
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        <div className='container-fluid' id='reletive' style={{ height: '90vh' }}>
          <div className='row border_2_1px table_date_header' >
            <div className='col-12  d-flex justify-content-between  table_header_font'>
              Stock Summary : {date?.filter_name} - {date?.name_nav || 'Primary'} : (Godown : {date?.location_name || 'Primary'})
              <span>  {`${date?.show_from_date} To ${date?.show_to_date} `}</span>
            </div>
          </div>
          <div className='row border_2_1px_bottom' style={{ height: 40 }}>
            <div className='border_2_1px_right border_2_1px_left  d-flex justify-content-start align-items-center table_header_font' style={{ width: '27%' }}>
              <b style={{ wordSpacing: '30px' }}> Particular </b>
            </div>
            <div className='m-0 p-0' style={{ width: '73%' }}>
              <div className='row m-0 p-0 ' style={{ width: '100%' }}>
                <div className='d-flex flex-column  border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Opening Balance</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '30%' }}>
                      Quantity
                    </div>
                    <div className='col-3 table_header_font p-0 m-0 text-end' style={{ width: '27%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '43%' }}>
                      Value
                    </div>
                  </div>
                </div>
                <div className='border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Inwards</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '30%' }}>
                      Quantity
                    </div>
                    <div className='col-3 table_header_font text-end p-0 m-0' style={{ width: '27%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '43%' }}>
                      Value
                    </div>
                  </div>
                </div>
                <div className='border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Outwards</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '30%' }}>
                      Quantity
                    </div>
                    <div className='col-3 m-0 p-0 text-end table_header_font' style={{ width: '27%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '43%' }}>
                      Value
                    </div>
                  </div>
                </div>
                <div className='border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Closing Balance</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '30%' }}>
                      Quantity
                    </div>
                    <div className='col-3 p-0 m-0 text-end table_header_font' style={{ width: '27%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '43%' }}>
                      Value
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={` row  border_2_1px_bottom postion-relative`} style={{ height: '76.5vh' }} >
            <div className='border_2_1px_right border_2_1px_left text-start table_body_font' style={{ width: '27%', height: '76.5vh' }} >
            </div>
            <div className='m-0 p-0' style={{ width: '73%', height: '76.5vh' }}>
              <div className='row m-0 p-0 ' style={{ width: '100%', height: '76.5vh' }}>
                <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '30%', overflow: 'hidden', wordSpacing: -4, whiteSpace: 'nowrap' }}>
                    </div>
                    <div className='col-3 m-0 p-0 text-end table_body_font' style={{ width: '27%', overflow: 'hidden', }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '43%', overflow: 'hidden', whiteSpace: 'nowrap', wordSpacing: -16 }}>
                    </div>
                  </div>
                </div>
                <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '30%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '27%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '43%' }}>
                    </div>
                  </div>
                </div>
                <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '30%' }}>
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '27%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '43%' }}>
                    </div>
                  </div>
                </div>
                <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '30%' }}>
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '27%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '43%' }}>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*console.log(data)}*/}
            <div className='row m-0 p-0' style={{ position: 'absolute', width: '100%', height: '76.5vh', overflowY: 'auto', overflowX: 'hidden' }} ref={boxRef}>
              <div className='col-12'>
                {
                  loading ?
                    <div className='col-12 d-flex align-items-center justify-content-center' style={{ height: '70vh' }}>
                      <Indicator />
                    </div> :
                    (() => {
                      currentGlobalIndex = 0;
                      return data?.map((outerItem, outerIndex) => {
                        const isHiddenPrimaryRow = date?.filter_name === 'Group-Wise' && outerItem?.group_name === 'Primary';
                        const isHiddenRow = isHiddenPrimaryRow || outerItem?.hideRow === true;
                        const showParent = date?.filter_name !== 'Item-Wise' && !isHiddenRow;
                        const parentGlobalIndex = showParent ? currentGlobalIndex++ : -1;

                        const getDirectTotal = (node, type) => {
                          let total = 0;
                          if (node?.items) {
                            node?.items.forEach((item) => {
                              if (type === 'opening') total += parseVal(item.grandOpeningData?.value || item.openingData?.value || 0);
                              else if (type === 'inward') total += parseVal(item.grandInwardData?.value || item.inwardData?.value || 0);
                              else if (type === 'outward') total += parseVal(item.grandOutwardData?.value || item.outwardData?.value || 0);
                              else if (type === 'closing') total += parseVal(item.grandClosingData?.value || item.closingData?.value || 0);
                            })
                          }
                          return total;
                        };

                        const isAtDepthZero = outerItem?.depth === 0 || outerItem?.depth === undefined;
                        if (!outerItem?.hideRow && isAtDepthZero) {
                          total_opening_value += parseVal(outerItem?.openingTotal);
                          total_inwards_value += parseVal(outerItem?.inwardTotal);
                          total_outwards_value += parseVal(outerItem?.outwardTotal);
                          total_closing_value += parseVal(outerItem?.closingTotal);
                        } else if (outerItem?.group_name === 'Primary' && outerItem?.hideRow === true) {
                          total_opening_value += getDirectTotal(outerItem, 'opening');
                          total_inwards_value += getDirectTotal(outerItem, 'inward');
                          total_outwards_value += getDirectTotal(outerItem, 'outward');
                          total_closing_value += getDirectTotal(outerItem, 'closing');
                        }
                        const isFilteredMainParent = date?.filter_name === 'Group-Wise' &&
                          date.stock_group_id !== '' &&
                          (date.stock_group_id.split(',').map(s => String(s.trim())).includes(String(outerItem?.stock_group_id || outerItem?.group_id || outerItem?.stock_gp_id || outerItem?.id)));
                        return (
                          <React.Fragment key={outerIndex}>
                            {showParent && (
                              <div>
                                <div
                                  style={{ cursor: isFilteredMainParent ? 'default' : 'pointer' }}
                                  className={`row ${(outerItem?.depth === 0 || outerItem?.depth === undefined) ? 'border_2_1px_top' : ''} ${parentGlobalIndex === selectedItemIndex ? selectedItems.includes(parentGlobalIndex) ? 'selected_multi_selected' : 'selected' : selectedItems.includes(parentGlobalIndex) ? 'selected_multi' : ''}`}
                                  onClick={() => setSelectedItemIndex(parentGlobalIndex)}
                                  onDoubleClick={() => {
                                    if (isFilteredMainParent) {
                                      return; // Do nothing for filtered main parent group row
                                    }
                                    if (outerItem?.stock_item?.stock_item_id) {
                                      onNavigateAway(parentGlobalIndex);
                                      navigate(`../stock_item_voucher/${outerItem.stock_item.stock_item_id}`, {
                                        state: {
                                          location_id: date.location_id,
                                          location_name: date.location_name || 'Primary',
                                          filter_name: date.filter_name,
                                          filter_value_names: date.name_nav !== 'Primary' ? date.name_nav : '',
                                          stock_group_id: date.stock_group_id || '',
                                          stock_category_id: date.stock_category_id || '',
                                          stock_company_id: date.stock_company_id || '',
                                          send_from_date: date.send_from_date,
                                          send_to_date: date.send_to_date
                                        }
                                      });
                                      return;
                                    }

                                    if (date.filter_name !== 'Item-Wise') {
                                      //console.log('outerItem', outerItem);
                                      const newDate = { ...date };
                                      let newNameNav = date.name_nav;

                                      if (date.filter_name === 'Group-Wise') {
                                        newDate.stock_group_id = outerItem?.stock_group_id || outerItem?.group_id || outerItem?.stock_gp_id || outerItem?.under || outerItem?.stock_item?.under || outerItem?.id || '';
                                        newNameNav = outerItem?.group_name || newNameNav;
                                        newDate.filter_name = 'Group-Wise';
                                      } else if (date.filter_name === 'Category-Wise') {
                                        newDate.stock_category_id = outerItem?.stock_category_id || outerItem?.category_id || outerItem?.stock_cat_id || outerItem?.under || outerItem?.stock_item?.under || outerItem?.id || '';
                                        newNameNav = outerItem?.category_name || newNameNav;
                                        newDate.filter_name = 'Category-Wise';
                                      } else if (date.filter_name === 'Company-Wise') {
                                        newDate.stock_company_id = outerItem?.stock_company_id || outerItem?.company_id || outerItem?.under || outerItem?.stock_item?.under || outerItem?.id || '';
                                        newNameNav = outerItem?.company_name || newNameNav;
                                        newDate.filter_name = 'Company-Wise';
                                      }

                                      newDate.name_nav = newNameNav !== 'Primary' ? newNameNav : '';
                                      //console.log(newDate);
                                      setDate(newDate);
                                      setSelectedItemIndex(0);
                                    }
                                  }}
                                >
                                  {/*console.log('outerItem', outerItem);*/}
                                  <div className={`text-start table_body_font fw-bold`} style={{ width: '27%', ...(outerItem?.depth !== undefined ? { paddingLeft: `${outerItem.depth * 10 + 8}px` } : {}) }}>
                                    {outerItem?.group_name === 'Primary' || outerItem?.category_name === 'Not Applicable' || outerItem?.company_name === 'Not Applicable' ?
                                      <i className="fas fa-diamond me-2" style={{ fontSize: '7px', verticalAlign: 'middle', height: '12px' }}></i>
                                      : null}
                                    {outerItem?.group_name || outerItem?.category_name || outerItem?.company_name || outerItem?.location_name || outerItem?.godown_name}
                                  </div>
                                  <div className='m-0 p-0' style={{ width: '73%' }}>
                                    <div className='row m-0 p-0 ' style={{ width: '100%' }}>
                                      <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                        <div className='row m-0 p-0' style={{ width: '100%' }}>
                                          <div className='col-12 text-end p-0 pe-1 m-0 table_body_font fw-bold' style={{ width: '100%' }}>
                                            {outerItem?.openingTotal !== 0 ? currencyFormate(outerItem?.openingTotal) : null}
                                          </div>
                                        </div>
                                      </div>
                                      <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                        <div className='row m-0 p-0' style={{ width: '100%' }}>
                                          <div className='col-12 text-end p-0 pe-1 m-0 table_body_font fw-bold' style={{ width: '100%' }}>
                                            {outerItem?.inwardTotal !== 0 ? currencyFormate(outerItem?.inwardTotal) : null}
                                          </div>
                                        </div>
                                      </div>
                                      <div className='border_2_1px_right text-nowrap  m-0 p-0' style={{ width: '25%' }}>
                                        <div className='row m-0 p-0' style={{ width: '100%' }}>
                                          <div className='col-12 text-end p-0 pe-1 m-0 table_body_font fw-bold' style={{ width: '100%' }}>
                                            {outerItem?.outwardTotal !== 0 ? currencyFormate(outerItem?.outwardTotal) : null}                                    </div>
                                        </div>
                                      </div>
                                      <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                        <div className='row m-0 p-0' style={{ width: '100%' }}>
                                          <div className='col-12 text-end p-0 pe-1 m-0 table_body_font fw-bold' style={{ width: '100%' }}>
                                            {outerItem?.closingTotal !== 0 ? currencyFormate(outerItem?.closingTotal) : null}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {outerItem?.items?.map((item, index) => {
                              const globalIndex = currentGlobalIndex++;
                              /*total_opening_value += parseFloat(item?.stock_item ? item?.grandOpeningData?.value : 0)
                              total_inwards_value += parseFloat(item?.stock_item ? item?.grandInwardData?.value : 0)
                              total_outwards_value += parseFloat(item?.stock_item ? item?.grandOutwardData?.value : 0)
                              total_closing_value += parseFloat(item?.stock_item ? item?.grandClosingData?.value : 0)*/
                              const parts = item?.grandOpeningData?.quantity?.split(' ');
                              const parts_1 = item?.grandInwardData?.quantity?.split(' ');
                              const parts_2 = item?.grandOutwardData?.quantity?.split(' ');
                              const parts_3 = item?.grandClosingData?.quantity?.split(' ');
                              // unit_name = parts[1]
                              // unit_name = 'Nos'
                              const unit_name = parts && parts.length > 1 ? parts[1] : '';
                              total_opnening_quantity += parseFloat(item?.stock_item && parts ? parts[0] : 0)
                              total_inwards_quantity += parseFloat(item?.stock_item && parts_1 ? parts_1[0] : 0)
                              total_outwards_quantity += parseFloat(item?.stock_item && parts_2 ? parts_2[0] : 0)
                              total_closing_quantity += parseFloat(item?.stock_item && parts_3 ? parts_3[0] : 0)
                              return (
                                <div
                                  style={{ cursor: 'pointer' }}
                                  key={index}
                                  className={`${selectedItems.includes(globalIndex) ? 'selected_multi' : ''}`}
                                  onClick={() => setSelectedItemIndex(globalIndex)}
                                  onDoubleClick={() => {
                                    onNavigateAway(globalIndex);
                                    navigate(`../stock_item_voucher/${item?.grandOpeningData?.stock_item_id}`, {
                                      state: {
                                        location_id: item?.location_id || date.location_id,
                                        location_name: item?.location_name || date.location_name || 'Primary',
                                        filter_name: date.filter_name,
                                        filter_value_names: date.name_nav !== 'Primary' ? date.name_nav : '',
                                        stock_group_id: date.stock_group_id || '',
                                        stock_category_id: date.stock_category_id || '',
                                        stock_company_id: date.stock_company_id || '',
                                        send_from_date: date.send_from_date,
                                        send_to_date: date.send_to_date
                                      }
                                    });
                                  }}
                                >
                                  <div
                                    className={`row ${(isHiddenPrimaryRow || outerItem?.hideRow) && index === 0 ? 'border_2_1px_top' : ''} ${globalIndex === selectedItemIndex ? selectedItems.includes(globalIndex) ? 'selected_multi_selected' : 'selected' : ''}`}
                                    style={!item?.stock_item ? { fontStyle: 'italic' } : {}}
                                  >
                                    <div className={`text-start table_body_font ${outerItem?.depth !== undefined ? '' : (item?.stock_item ? 'ps-3' : 'ps-4')}`} style={{ width: '27%', ...(outerItem?.depth !== undefined ? { paddingLeft: `${(outerItem.depth + (outerItem?.group_name === 'Primary' ? 0 : 1)) * 10 + (item?.stock_item ? 8 : 16)}px` } : {}) }}>
                                      {item?.stock_item?.item_name} {item?.location_name || item?.godown_name || item?.name}
                                    </div>
                                    <div className='m-0 p-0' style={{ width: '73%' }}>
                                      <div className='row m-0 p-0 ' style={{ width: '100%' }}>
                                        <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                          <div className='row m-0 p-0' style={{ width: '100%' }}>
                                            <div className='col-3 text-end text-nowrap p-0 m-0 table_body_font' style={{ width: '30%', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                              {formatValue(item?.grandOpeningData?.quantity)}
                                            </div>
                                            <div className='col-3 m-0 p-0  text-end table_body_font' style={{ width: '27%', overflow: 'hidden', }}>
                                              {formatValue(item?.grandOpeningData?.rate, currencyFormate)}
                                            </div>
                                            <div className='col-3 text-end p-0 m-0 pe-1 table_body_font' style={{ width: '43%', overflow: 'hidden', whiteSpace: 'nowrap', wordSpacing: -7 }}>
                                              {formatValue(item?.grandOpeningData?.value, currencyFormate)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                          <div className='row m-0 p-0' style={{ width: '100%' }}>
                                            <div className='col-3 text-end text-nowrap p-0 m-0 table_body_font' style={{ width: '30%' }}>
                                              {formatValue(item?.grandInwardData?.quantity)}
                                            </div>
                                            <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '27%' }}>
                                              {formatValue(item?.grandInwardData?.rate, currencyFormate)}
                                            </div>
                                            <div className='col-3 text-end p-0 pe-1 m-0 table_body_font' style={{ width: '43%' }}>
                                              {formatValue(item?.grandInwardData?.value, currencyFormate)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className='border_2_1px_right text-nowrap  m-0 p-0' style={{ width: '25%' }}>
                                          <div className='row m-0 p-0' style={{ width: '100%' }}>
                                            <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '30%' }}>
                                              {formatValue(item?.grandOutwardData?.quantity)}
                                            </div>
                                            <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '27%' }}>
                                              {formatValue(item?.grandOutwardData?.rate, currencyFormate)}
                                            </div>
                                            <div className='col-3 text-end p-0 pe-1 m-0 table_body_font' style={{ width: '43%' }}>
                                              {formatValue(item?.grandOutwardData?.value, currencyFormate)}
                                            </div>
                                          </div>
                                        </div>
                                        <div className='border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                          <div className='row m-0 p-0' style={{ width: '100%' }}>
                                            <div className='col-3 text-end text-nowrap p-0 m-0 table_body_font' style={{ width: '30%' }}>
                                              {formatValue(item?.grandClosingData?.quantity)}
                                            </div>
                                            <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '27%' }}>
                                              {formatValue(item?.grandClosingData?.rate, currencyFormate)}
                                            </div>
                                            <div className='col-3 text-end p-0 pe-1 m-0 table_body_font' style={{ width: '43%' }}>
                                              {formatValue(item?.grandClosingData?.value, currencyFormate)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                          </React.Fragment>
                        )
                      })
                    })()
                }

              </div>
            </div>
          </div>


          <div className={`row border_2_1px_bottom ${data?.length > 0 ? 'border-top-0' : ''}`}>
            <div className='border_2_1px_right text-start table_footer_font' style={{ width: '27%' }}>
              Grand Total
            </div>
            <div className='m-0 p-0' style={{ width: '73%' }}>
              <div className='row m-0 p-0 ' style={{ width: '100%' }}>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_footer_font' style={{ width: '30%', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                      {/* {`${total_opnening_quantity == 0 ? '' : total_opnening_quantity} ${unit_name}`} */}
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_footer_font' style={{ width: '27%', overflow: 'hidden', }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '43%', overflow: 'hidden', whiteSpace: 'nowrap', wordSpacing: -7 }}>

                      {
                        total_opening_value == 0 ? '' :
                          total_opening_value?.toFixed(userData?.no_of_decimal_place).replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")}
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3  text-end p-0 m-0 table_footer_font' style={{ width: '30%' }}>
                      {/* {`${total_inwards_quantity == 0 ? '' : total_inwards_quantity} ${unit_name}`} */}
                    </div>
                    <div className='col-3  text-end table_footer_font p-0 m-0' style={{ width: '27%' }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '43%' }}>
                      {
                        total_inwards_value == 0 ? '' :
                          total_inwards_value?.toFixed(userData?.no_of_decimal_place).replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")}
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3  text-end p-0 m-0 table_footer_font' style={{ width: '30%' }}>
                      {/* {`${total_outwards_quantity == 0 ? '' : total_outwards_quantity} ${unit_name}`} */}
                    </div>
                    <div className='col-3  text-end m-0 p-0 table_footer_font' style={{ width: '27%' }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '43%' }}>
                      {
                        total_outwards_value == 0 ? '' :
                          total_outwards_value?.toFixed(userData?.no_of_decimal_place).replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")}
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3  text-end p-0 m-0 table_footer_font' style={{ width: '30%' }}>
                      {/* {`${total_closing_quantity == 0 ? '' : total_closing_quantity} ${unit_name}`} */}
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_footer_font' style={{ width: '27%' }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '43%' }}>
                      {
                        total_closing_value == 0 ? '' :
                          total_closing_value?.toFixed(userData?.no_of_decimal_place).replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <StockItemSummaryFooter
          isDisable={removedItems.length === 0}
          spaceFunction={() => toggleSelection(selectedItemIndex)}
          removeLineFunction={() => removeSelectedItems()}
          restoreLineFunction={() => restoreSelectedItems()}
        />
      </div>
      <div className='help border_1_1px_left backgroud_color_1 position-relative'>
        {modal_state.period || modal_state.godownWise || modal_state.stockCate || modal_state.stockCompany || modal_state.stockGroup || modal_state.basic || modal_state.changeView || modal_state.exceptionReports || modal_state.saveView || modal_state.valuation || modal_state.summaryType ? null :
          <Stock_Summary_Help date={date} f4Enable={f4Enable} items_formate_of_report={state_configure.items_formate_of_report} godowns_formate_of_report={state_configure.godowns_formate_of_report} />
        }
      </div>
    </div>
  )
}

export default StockSummary
